import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../store/slices/employeeSlice";
import { useEffect, useMemo } from "react";
import { resolveLoggedUserLocale } from "./currencyUtils";

const DateConversion = () => {
  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state?.employees);

  useEffect(() => {
    dispatch(fetchEmployees());
  }, [dispatch]);

  const locale = useMemo(() => resolveLoggedUserLocale(employees), [employees]);
  const countryCode = locale?.countrycode;
  const region = String(locale?.region || "").trim().toUpperCase();
  const isUsLocale = countryCode === "+1" || countryCode === "1" || region === "US" || region === "USA";
  const isInLocale = countryCode === "+91" || countryCode === "91" || region === "IN" || region === "INDIA";

  // ------------ DATE FORMATTER ------------
  const formatDateByCountry = (dateInput) => {
    if (!dateInput) return "";

    const date = new Date(dateInput);
    if (isNaN(date)) return "";

    if (isUsLocale) {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }); // mm/dd/yyyy
    }

    if (isInLocale) {
      return date.toLocaleDateString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }); // dd/mm/yyyy
    }

    return date.toISOString().split("T")[0]; // yyyy-mm-dd
  };

  // ------------ PLACEHOLDER FORMATTER ------------
  const getDatePlaceholder = () => {
    if (isUsLocale) return "MM/DD/YYYY";
    if (isInLocale) return "DD/MM/YYYY";
    return "YYYY-MM-DD";
  };

  const getDateFormat = () => {
    if (isUsLocale) return "MM/dd/yyyy";
    if (isInLocale) return "dd/MM/yyyy";
    return "yyyy-MM-dd";
  };


  return { formatDateByCountry, getDatePlaceholder, getDateFormat };
};

export default DateConversion;
